import { Component, OnInit, ViewChild } from "@angular/core";
import { AuthServerProvider } from "../shared/auth/auth.service";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { StateService } from "@uirouter/angular";
import { switchMap } from "rxjs/operators";
import { PasswordOperations } from "./password-operations.component";

@Component({
    template: require('./forgot-password.component.html')
})
export class ForgotPassword implements OnInit {
    constructor(
        private authServerProvider: AuthServerProvider,
        private fb: FormBuilder,
        private stateService: StateService) { }

    forgotPasswordForm: FormGroup;

    get Email() { return this.forgotPasswordForm.get("Email"); }

    get Company() { return this.forgotPasswordForm.get("Company"); }

    @ViewChild(PasswordOperations) passwordOperations: PasswordOperations;

    ngOnInit(): void {
        this.forgotPasswordForm = this.fb.group({
            Email: ['', [Validators.required, Validators.email]],
            Company: ['', Validators.required]
        });
    }

    onSubmit(): void {

        this.passwordOperations.performAction(
            () => this.authServerProvider.getPasswordResetInfo(this.forgotPasswordForm.value).pipe(
                switchMap(passwordResetInfo => this.authServerProvider.sendPasswordResetLink(
                    {
                        UserId: passwordResetInfo.UserId,
                        Company: this.Company.value,
                        ResetUrl: this.stateService.href(
                            "app.password.reset",
                            { userId: passwordResetInfo.UserId, company: this.Company.value, token: passwordResetInfo.Token },
                            { absolute: true })
                    }))),
            "Password reset link has been sent",
            "Failed to send password reset link");
    }

    cancel(): void {
        this.stateService.go("app.home");
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/password/forgot-password.component.ts